import { defineMessages } from 'react-intl';

export default defineMessages({
  satisfaction_question: {
    id: 'kustomer.chat.message.article.list.satisfaction.question.text',
    description: 'Satisfaction question text',
    defaultMessage: 'Did you find those articles helpful?',
  },
});
